"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketplaceReportSearchForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_inputs_picker_1 = require("@dzambalaorg/mui-inputs-picker");
const mui_inputs_entity_1 = require("@dzambalaorg/mui-inputs-entity");
const mui_form_search_1 = require("@dzambalaorg/mui-form-search");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const inputs_1 = require("../../../../../inputs");
const types_1 = require("../../../../../types");
const constants_1 = require("../../../../../constants");
const MarketplaceReportSearchForm = (props) => {
    const { initialSearchValues, service } = props;
    const renderEntityInput = {
        [types_1.ServiceType.ADMIN]: ((0, jsx_runtime_1.jsx)(mui_inputs_entity_1.EntityInput, { name: "contractIds", controller: "contracts", multiple: true, fetchData: { contractType: constants_1.merchantContractsFetchData[service] } })),
        [types_1.ServiceType.OFFICE]: ((0, jsx_runtime_1.jsx)(inputs_1.SearchMerchantContractsInput, { name: "contractIds", multiple: true, fetchData: { contractType: constants_1.merchantContractsFetchData[service] } })),
    };
    return ((0, jsx_runtime_1.jsx)(mui_form_search_1.SearchWithFilters, { initialValues: initialSearchValues, children: (0, jsx_runtime_1.jsxs)(ui_kit_1.FormGrid, { columns: service === types_1.ServiceType.OFFICE ? [2, 1, 2] : [2, 2], containerProps: { sx: theme => ({ marginTop: theme.spacing(theme.tokens.spacing.xl) }) }, children: [(0, jsx_runtime_1.jsx)(mui_inputs_picker_1.DateTimeInput, { slotProps: {
                        popper: {
                            sx: {
                                "& .MuiPickersTextField-root": {
                                    margin: 0,
                                },
                            },
                        },
                    }, name: "startTimestamp", size: "small" }), (0, jsx_runtime_1.jsx)(mui_inputs_picker_1.DateTimeInput, { slotProps: {
                        popper: {
                            sx: {
                                "& .MuiPickersTextField-root": {
                                    margin: 0,
                                },
                            },
                        },
                    }, name: "endTimestamp", size: "small" }), service === types_1.ServiceType.OFFICE && (0, jsx_runtime_1.jsx)(inputs_1.SearchMerchantInput, {}), renderEntityInput[service], (0, jsx_runtime_1.jsx)(inputs_1.TemplateInput, {})] }) }));
};
exports.MarketplaceReportSearchForm = MarketplaceReportSearchForm;
//# sourceMappingURL=index.js.map